import { CSSProperties } from 'react';

export const searchStyles = {
    root: {
        position: 'relative',
    } satisfies CSSProperties,
    leadingIcon: {
        position: 'absolute',
        left: 12,
        top: '50%',
        transform: 'translateY(-50%)',
        zIndex: 1,
        pointerEvents: 'none',
        color: '#6b7280',
    } satisfies CSSProperties,
    trailingIcon: {
        position: 'absolute',
        right: 12,
        top: '50%',
        transform: 'translateY(-50%)',
        zIndex: 1,
        color: '#6b7280',
    } satisfies CSSProperties,
    clearButton: {
        position: 'absolute',
        right: 8,
        top: '50%',
        transform: 'translateY(-50%)',
        zIndex: 2,
        width: 28,
        height: 28,
        padding: 0,
        border: 0,
        borderRadius: 9999,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#64748b',
        backgroundColor: 'transparent',
        cursor: 'pointer',
    } satisfies CSSProperties,
    input: {
        width: '100%',
        height: 40,
        borderRadius: 9999,
        border: '1px solid #d1d5db',
        backgroundColor: '#ffffff',
        color: '#111827',
        paddingLeft: 40,
        paddingRight: 40,
        fontSize: 16,
        lineHeight: '20px',
        fontWeight: 400,
        outline: 'none',
        boxSizing: 'border-box',
        appearance: 'none',
        WebkitAppearance: 'none',
    } satisfies CSSProperties,
    inputMobile: {
        height: 44,
    } satisfies CSSProperties,
    dropdown: {
        position: 'absolute',
        left: 0,
        right: 0,
        top: 'calc(100% + 8px)',
        zIndex: 60,
        overflow: 'hidden',
        borderRadius: 10,
        border: '1px solid #e5e7eb',
        backgroundColor: '#ffffff',
        boxShadow: '0 18px 40px rgba(15, 23, 42, 0.16)',
    } satisfies CSSProperties,
    dropdownDesktop: {
        maxHeight: 420,
        backgroundColor: '#ffffff',
        overflowY: 'auto',
    } satisfies CSSProperties,
    dropdownMobile: {
        maxHeight: '60vh',
    } satisfies CSSProperties,
    resultsScroller: {
        overflowY: 'auto',
    } satisfies CSSProperties,
    emptyState: {
        padding: '10px 14px',
        fontSize: 13,
        lineHeight: '18px',
        fontWeight: 400,
        color: '#6b7280',
    } satisfies CSSProperties,
    list: {
        listStyle: 'none',
        margin: 0,
        padding: 0,
    } satisfies CSSProperties,
    listItem: {
        margin: 0,
        padding: 0,
        borderTop: '1px solid #f3f4f6',
    } satisfies CSSProperties,
    firstListItem: {
        borderTop: 'none',
    } satisfies CSSProperties,
    resultLinkBase: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: 12,
        padding: '10px 14px',
        textDecoration: 'none',
        transition: 'background-color 160ms ease',
        color: 'inherit',
    } satisfies CSSProperties,
    resultLinkDefault: {
        backgroundColor: '#ffffff',
    } satisfies CSSProperties,
    resultLinkInteractive: {
        backgroundColor: '#f9fafb',
    } satisfies CSSProperties,
    resultLinkActive: {
        backgroundColor: '#f3f4f6',
    } satisfies CSSProperties,
    thumbWrap: {
        width: 48,
        height: 48,
        flexShrink: 0,
        overflow: 'hidden',
        borderRadius: 8,
        backgroundColor: '#f3f4f6',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    } satisfies CSSProperties,
    thumbImage: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        display: 'block',
    } satisfies CSSProperties,
    content: {
        minWidth: 0,
        flex: 1,
        display: 'grid',
        gridTemplateColumns: 'minmax(0, 1fr)',
        alignContent: 'center',
        justifyItems: 'start',
        alignSelf: 'stretch',
        rowGap: 3,
    } satisfies CSSProperties,
    category: {
        width: '100%',
        minWidth: 0,
        maxWidth: '100%',
        margin: 0,
        color: '#64748b',
        fontSize: 10,
        lineHeight: '13px',
        fontWeight: 700,
        letterSpacing: '0.02em',
        textTransform: 'uppercase',
        display: '-webkit-box',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        overflowWrap: 'normal',
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: 1,
    } satisfies CSSProperties,
    title: {
        width: '100%',
        minWidth: 0,
        margin: 0,
        color: '#111827',
        fontSize: 13,
        lineHeight: '18px',
        fontWeight: 600,
        display: '-webkit-box',
        whiteSpace: 'normal',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        overflowWrap: 'anywhere',
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: 2,
    } satisfies CSSProperties,
    description: {
        width: '100%',
        minWidth: 0,
        margin: '4px 0 0 0',
        color: '#6b7280',
        fontSize: 11,
        lineHeight: '15px',
        fontWeight: 400,
        display: '-webkit-box',
        whiteSpace: 'normal',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        overflowWrap: 'anywhere',
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: 2,
    } satisfies CSSProperties,
} as const;
